import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ModalBody, ModalHeader, ModalHeaderTitle } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { ItemOwnersModalContentFragment } from "./ItemOwnersModalContent.fragment";
import { ItemOwnersTable } from "./ItemOwnersTable";
export function ItemOwnersModalContent(t0) {
  const $ = _c(11);
  const {
    item: itemKey
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ItemOwnersModalContentFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  const t = useTranslations("ItemOwnersModalContent");
  let t2;
  if ($[2] !== t) {
    t2 = t("ownedBy");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <ModalHeader><ModalHeaderTitle>{t2}</ModalHeaderTitle></ModalHeader>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== item) {
    t4 = <ModalBody className="max-h-[600px]"><ItemOwnersTable item={item} /></ModalBody>;
    $[6] = item;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}